import type { CommonParams } from 'analytics/types/CommonParams'
import { EECEventType } from 'analytics/types/EEC'
import { getCommonParams } from 'analytics/utils/getCommonParams/getCommonParams'
import {
	type EECItem,
	getEECItems,
	type ItemWithPrices,
} from 'analytics/utils/getEECItems/getEECItems'
import type { Session } from 'session/src/types/session'
import type { MasterData } from 'types/masterData'

export interface MapViewItemListToBeaconProps {
	masterData: MasterData
	session: Session
	payload: ViewItemListPayload
}

export interface ViewItemListPayload {
	items: ItemWithPrices[]
	listId?: string
}

export interface BeaconViewItemListEvent {
	name: EECEventType.VIEW_ITEM_LIST
	params: CommonParams & {
		items: EECItem[]
	}
}

export const mapViewItemListToBeacon = ({
	masterData,
	session,
	payload,
}: MapViewItemListToBeaconProps): BeaconViewItemListEvent => ({
	name: EECEventType.VIEW_ITEM_LIST,
	params: {
		...getCommonParams({
			masterData,
			session,
			listId: payload.listId,
		}),
		items: getEECItems(payload.items),
	},
})
